/**
 * @file: PlatformNotEnabledScreen.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { useLogout } from '@euler/app/flows/auth/hooks';
import { EmptyView } from '@euler/components/EmptyView';
import { kStoreFeatureNames } from '@euler/functions/entitlements/storeFeatureNames';
import { StoreFeature } from '@euler/model/enum';
import { memo } from 'react';

/**
 * The whole app when the store has not bought this build: nothing else
 * works, so the one way on is another account.
 */
export const PlatformNotEnabledScreen = memo(
  ({ feature }: { feature: StoreFeature }) => {
    const logout = useLogout();
    return (
      <EmptyView
        message={`当前门店尚未开通${kStoreFeatureNames[feature]}，如需开通请联系知车客服。`}
        buttonText="退出登录"
        onRetry={() => void logout()}
      />
    );
  },
);
